import { render, staticRenderFns } from "./salesaeteam.vue?vue&type=template&id=0b0ca723"
import script from "./salesaeteam.vue?vue&type=script&lang=js"
export * from "./salesaeteam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports